<template>
  <div class="modalback">
    <div class="modalcontent container">
      <div class="close cursor-pointer"><img src="@/assets/acrypro/close.svg" @click="closeAction"/></div>
      <div class="row justify-content-center align-items-center" style="min-height: 90px;">
          <div class="col" style="white-space: break-spaces;">
              <div class="text-center acry-text-title" style="font-size: 20px; white-space: pre-wrap;" v-text="this.$store.state.yesNoDialogMessage" />
          </div>
      </div>
      <div class="row justify-content-center pt-5" style="">
          <div class="col-auto d-flex flex-row justify-content-between" style="width: 550px">
              <button class="acry-btn-secondary-normal btn-size" @click="closeAction">キャンセル</button>
              <button class="acry-btn-primary-normal btn-size" @click="okAction">OK</button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: "YesNoDialogAp",
  props: {},
  data: function () {
    return {
    };
  },
  mounted: function () {
    // 画面の遷移があるか調べる
  },
  methods: {
      okAction(){
        this.$store.state.yesNoDialogCallback()
        this.$store.commit("hideYesNoDialog")
      },
      closeAction(){
          this.$store.commit("hideYesNoDialog")
      }
      
  },
  components: {
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.modalback {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  position: relative;
  z-index: 201;
  width: 800px;
  /* height: 200px; */
  padding: 40px;
  background-color: #FEFEFE;
  border-radius: 8px;
}
.close {
  position: absolute;
  width: 48px;
  right: 40px;
}
.btn-size{
  width: 240px;
  height: 56px;
}
</style>
